( ( $ ) => {
	let Hotjar = {};
	window.hj = window.hj || function () { ( window.hj.q = window.hj.q || [] ).push( arguments ) };

	Hotjar.init = () => {
		$( '.js-search-open' ).on( 'click', () => {
			window.hj( 'event', 'search' );
		} );


		$( '.js-filter-open' ).on( 'click', () => {
			window.hj( 'event', 'filter' );
		} );
	};

	$( document ).on( 'ready', Hotjar.init );
} )( jQuery );


// WEBPACK FOOTER //
// ./scripts/tracking/hotjar.js